export default __webpack_public_path__ + "static/media/contextual-chocolate.e04f98e8.png";